export enum VertrouwelijkheidEnum {
  GEMEENTE = 'Gemeente',
  OPENBAAR = 'Openbaar',
  PROVINCIE = 'Provincie',
}
